import { render, staticRenderFns } from "./ModalNewUserGuide.vue?vue&type=template&id=578f063e&scoped=true"
import script from "./ModalNewUserGuide.vue?vue&type=script&lang=ts"
export * from "./ModalNewUserGuide.vue?vue&type=script&lang=ts"
import style0 from "./ModalNewUserGuide.vue?vue&type=style&index=0&id=578f063e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578f063e",
  null
  
)

export default component.exports